import { Loading } from "@bluframe/blublocks"
import Typography from "components/Typography"

import type { ComponentProps } from "."
import {
  HandleRow,
  HandleRowMain,
  HandleRowMeta,
  Handles,
  ProspectsLi,
  ProspectsUl,
  SectionTitle
} from "./styled"

type Props = Pick<
  ComponentProps,
  | "handles"
  | "hasActiveFilters"
  | "isLoading"
  | "onSelectHandleClick"
  | "selectedHandle"
>

const ProspectQueueList = ({
  handles,
  hasActiveFilters,
  isLoading,
  onSelectHandleClick,
  selectedHandle
}: Props) => (
  <Handles aria-label="Prospects list" role="region">
    <SectionTitle>{`Prospects (${handles.length})`}</SectionTitle>

    {isLoading ? <Loading /> : null}

    {!isLoading && handles.length === 0 ? (
      <Typography.Paragraph>
        {hasActiveFilters
          ? "No prospects match your filters."
          : "No prospects yet."}
      </Typography.Paragraph>
    ) : null}

    {!isLoading && handles.length ? (
      <ProspectsUl aria-label="Prospects">
        {handles.map((handle) => (
          <ProspectsLi key={handle.id}>
            <HandleRow
              $isSelected={selectedHandle?.id === handle.id}
              ariaLabel={`Prospect ${handle.handle}`}
              noHoverHighlight
              onClick={onSelectHandleClick(handle)}
              type="button"
            >
              <HandleRowMain>
                <Typography.Paragraph>
                  {handle.displayName ?? handle.handle}
                </Typography.Paragraph>

                <Typography.SubtitleH3>{handle.handle}</Typography.SubtitleH3>
              </HandleRowMain>

              <HandleRowMeta>
                <Typography.SubtitleH3>{`Score ${handle.score.toFixed(
                  2
                )}`}</Typography.SubtitleH3>

                <Typography.SubtitleH3>
                  {handle.relationshipState}
                </Typography.SubtitleH3>

                {handle.isIgnored ? (
                  <Typography.SubtitleH3>{"Ignored"}</Typography.SubtitleH3>
                ) : null}
              </HandleRowMeta>
            </HandleRow>
          </ProspectsLi>
        ))}
      </ProspectsUl>
    ) : null}
  </Handles>
)

export default ProspectQueueList
